"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../../common/Modal/Modal"));
var _SendReceiveTwoFactorAuthForm = _interopRequireDefault(require("./SendReceiveTwoFactorAuthForm"));
require("./SendReceiveTwoFactorAuthModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SendReceiveTwoFactorAuthModal = function SendReceiveTwoFactorAuthModal(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("auth"),
    t = _useTranslation.t;
  var handleSubmit = props.handleSubmit,
    submitting = props.submitting,
    isOpen = props.isOpen,
    close = props.close,
    error = props.error;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: t("Two-Factor Authentication"),
    onCancel: function onCancel() {
      close();
    },
    close: close
  }, /*#__PURE__*/_react["default"].createElement(_SendReceiveTwoFactorAuthForm["default"], {
    handleSubmit: handleSubmit,
    submitting: submitting,
    error: error
  }));
};
SendReceiveTwoFactorAuthModal.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};
SendReceiveTwoFactorAuthModal.propTypes = {
  close: _propTypes["default"].func.isRequired,
  handleSubmit: _propTypes["default"].func
};
var _default = exports["default"] = SendReceiveTwoFactorAuthModal;